import { render } from "./PortfolioToggleButton.vue?vue&type=template&id=3ea49f82"
import script from "./PortfolioToggleButton.js?vue&type=script&lang=js"
export * from "./PortfolioToggleButton.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__